<template>
    <b-row class="mt-4">
        <b-col>
            <b-button variant="secondary"
                      @click="previousStep"
                      style="width: 100%;"
                      class="btn-action"
            >
                {{ $t(previousStepText) }}
            </b-button>
        </b-col>
        <b-col>
            <b-button variant="primary"
                      style="width: 100%"
                      @click="nextStep"
                      class="btn-action"
            >
                {{ $t(nextStepText) }}
            </b-button>
        </b-col>
    </b-row>
</template>
<script>
export default {
    name: 'StepperButtons',
    props: {
        nextStep: {},
        previousStep: {},
        previousStepText: {
            default: 'common.previousStep',
        },
        nextStepText: {
            default: 'common.continue'
        }
    }
}
</script>
